module.exports = __webpack_public_path__ + "static/media/P6040984.b5a31d19.JPG";